import { ITeam } from "@gtmhub/teams";
import { IAssignee } from "@gtmhub/assignees";
import dayjs from "@gtmhub/dayjs";
import { IReflectionContributor } from "../models/reflection-contributor-list.models";

export function startWithFieldValue<T extends { [K in keyof T] }>(field: keyof T, valueToStartWith: T[keyof T]): (a: T, b: T) => number {
  return function (a: T, b: T): number {
    return a[field] === valueToStartWith ? -1 : b[field] === valueToStartWith ? 1 : 0;
  };
}

export const extractUniqueTeamMemberIds = (team: ITeam): string[] => {
  return [...new Set([...(team.members || []), ...(team.manager ? [team.manager] : [])])];
};

export const toEnrichedContributorListMember = (member: IAssignee, params = { withDotIndicator: false }): IReflectionContributor => ({
  ...member,
  avatar: member.picture || member.avatar,
  withDotIndicator: params.withDotIndicator,
});

export const getLastMondayAsDate = (): string => {
  return dayjs().startOf("isoWeek").toISOString();
};

export const getLastDayOfCadence = (cadenceStartDate: string, cadenceDurationInDays: number): string => {
  return dayjs(cadenceStartDate)
    .utc()
    .add(cadenceDurationInDays - 1, "day")
    .toISOString();
};
